import React, { useState, useEffect } from 'react';
import { RadioButton } from '@zydalabs/storefront-components';
import VariantOptionField from '../../../VariantOptionField';
import { Option } from '../../../../../../service/types/generated';
import { usePersistedCountryDetails } from '../../../../../../common/hooks';

type OptionMutationType = {
  optionId: string;
  optionGroupId: string;
  optionQuantity?: number;
};

type SingleOptionType = {
  existedOptionId: string;
  options: Array<Option>;
  addSingleOption: (x: OptionMutationType) => void;
  setError: (x: boolean) => void;
  isArabic: boolean;
  selectedOptionId?: string;
};

const SingleOption: React.FC<SingleOptionType> = ({
  existedOptionId,
  options,
  addSingleOption,
  setError,
  isArabic,
  selectedOptionId,
}) => {
  const [singleOptionSelection, setSingleOptionSelection] = useState<string>();
  const [persistedCountryDetails] = usePersistedCountryDetails();
  const { currency } = persistedCountryDetails || {};

  useEffect(() => {
    if (!singleOptionSelection) setError(true);
    else setError(false);
  }, [singleOptionSelection]);

  useEffect(() => {
    if (selectedOptionId !== singleOptionSelection) setSingleOptionSelection(selectedOptionId);
  }, [selectedOptionId]);

  const onSingleOptionSelection = (value: string) => {
    addSingleOption({
      optionId: value,
      optionGroupId: existedOptionId,
      optionQuantity: 1,
    });
    setError(false);
    setSingleOptionSelection(value);
  };

  return (
    <RadioButton
      fields={options?.map(option => ({
        content: (
          <VariantOptionField
            key={option.uuid}
            fieldTitle={isArabic ? option.titleAr : option.titleEn}
            price={option.price}
            currency={currency}
          />
        ),
        fieldValue: option.uuid,
      }))}
      onChange={onSingleOptionSelection}
      value={singleOptionSelection}
      name={existedOptionId}
      mt={2}
    />
  );
};

export default SingleOption;
